module.exports = __webpack_public_path__ + "static/media/pumpkins-small.865f740b.gif";